import { connect } from 'react-redux';
import compose from 'recompose/compose';
import withState from 'recompose/withState';
import withHandlers from 'recompose/withHandlers';

import { sharedEnhancer } from '../Shared';
import { appointmentsImport, deleteImportedAppointments } from '../../actions';
import confirmModal from '../../../../common/confirmModal';

const mapDispatchToProps = {
  import: appointmentsImport,
  deleteImportedAppointments,
};

const enhance = compose(
  connect(null, mapDispatchToProps),
  sharedEnhancer,
  withState('importResults', 'setImportResults', false),
  withHandlers({
    onChange: props => (e) => {
      props.setImportResults(false);
      props.onChange(e);
    },
    deleteAppointments: props => async () => {
      const confirmed = await confirmModal({
        type: 'danger',
        title: 'Delete unpaid imported appointments',
        message: 'Are you sure you want to delete all unpaid imported appointments at the shop?',
      });

      if (!confirmed) {
        return false;
      }

      return props.deleteImportedAppointments(props.params.id).then(response => props.addNotification({
        level: 'success',
        message: `Deleted ${response.deleted} appointments.`,
        autoDismiss: 20,
        title: 'Success',
      }));
    },
    onSubmit: props => (e) => {
      props.onSubmit(e).then((result) => {
        const messages = [
          `Imported ${result.addedCount} appointments.`,
          `Skipped ${result.barberNotFoundCount} appointments because barber was not found.`,
          `Added ${result.blockedTimeNoServiceCount} block times because service was not found.`,
          `Skipped adding ${result.overlappingCount} appointments because they overlap.`,
        ];

        props.setImportResults(messages);
      });
    },
  })
);

export default enhance;
